import { css, Theme } from '@emotion/react'

export const membershipLogsTable = (theme: Theme) => css`
  border: 1px solid ${theme.colors.backgroundOne};
  border-radius: 20px;
  row-gap: 0px;

  .table-row {
    border: none;
    box-shadow: none;
    padding: ${theme.spacing(1.75, 2)};
    border-radius: 0;
    min-height: 60px;

    &:nth-of-type(2n + 2) {
      background: ${theme.colors.backgroundFive};
    }

    &:first-of-type {
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
    }

    &:last-of-type {
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
    }
  }

  .table-cell {
    color: ${theme.colors.typographyThree};

    line-height: 28px;
  }
`

export const secondaryTitle = css`
  font-size: 18px;
  font-weight: 600;
`

export const form = (theme: Theme) => css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: ${theme.spacing(2)};
  row-gap: ${theme.spacing(2)};

  padding: ${theme.spacing(2)};
  border-radius: 20px;

  background-color: ${theme.colors.backgroundFive};

  ${theme.breakpoints.down(900)} {
    display: flex;
    flex-direction: column;
  }
`

export const column = (theme: Theme) => css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${theme.spacing(2)};

  ${theme.breakpoints.down(500)} {
    display: flex;
    flex-direction: column;
  }
`

export const submitButton = css`
  grid-column-start: 1;
  grid-column-end: 3;
`
